import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import { useFloatingChat } from '../../contexts/FloatingChatContext';

export const FloatingChatButton: React.FC = () => {
  const { openChat, isOpen } = useFloatingChat();

  // Don't show button if chat is already open
  if (isOpen) return null;

  return (
    <Tooltip title="AI Interview Coach" placement="left">
      <Fab
        color="primary"
        onClick={() => openChat()}
        sx={{
          position: 'fixed',
          bottom: 32,
          right: 32,
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
          zIndex: 1200,
        }}
      >
        <ChatIcon />
      </Fab>
    </Tooltip>
  );
};
